export enum ScreenEnum {
  DASHBOARD,
  MAP_PAGE,
  SETTINGS,
  SI_LINKING
}
